import React from "react";
import { CardContent } from "@material-ui/core";
import Swal from "sweetalert2";
// import { makeStyles } from "@material-ui/core/styles";
import "./cardcompra.css";

import { domain } from "../../../Urls/Services/Api_urls";
import { DashboardSpeed, ModernTv, Wifi, Cart, Phone, DataTransferBoth } from "iconoir-react";
function Cardcomprasin(props) {
  const precio = props.precio_persona;
  var Categoria = "";
  let adress = window.sessionStorage.getItem("direction");
  let cdo = window.sessionStorage.getItem("cdo");
  let zone = window.sessionStorage.getItem("zone");
  let suscri = window.sessionStorage.getItem("cont");
  let estrato = window.sessionStorage.getItem("estrato");
  let city_owner = window.sessionStorage.getItem("city_owner");
  let nombre = window.sessionStorage.getItem("name");
  let dni = window.sessionStorage.getItem("dni");
  const token = window.sessionStorage.getItem("token");
  const nombre_plan = window.sessionStorage.getItem("Nombreplanin");
  const valor_plan = precio[props.estrato]
  const idact = window.sessionStorage.getItem("idact");
  const localization = window.sessionStorage.getItem("localization");
  const Cate = () => {
    if (estrato === "Empresas") {
      Categoria = "Empresas";
    } else {
      Categoria = "Residencial";
    }
  };



  const updateplan = (value) => {
    window.sessionStorage.setItem("idplan", value.id__planes);
    window.sessionStorage.setItem("Nombreplanin", value.nombreplan);
    window.sessionStorage.setItem("price_plan", parseInt(value.precio_persona));
    window.sessionStorage.setItem("plan_type", value.tipoplan);
    window.sessionStorage.setItem("id_plan_open", value.codigo_open);
    // window.sessionStorage.setItem("price_plan", value.price);
    Swal.fire({
      title: JSON.stringify(value.nombreplan),
      text: "¿Quieres aumentar al paquetes seleccionado?",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Comprar",
    }).then((result) => {
      if (result.isConfirmed) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          redirect: "follow",
        };

        fetch(
          domain +
          "/postventa/" +
          idact +
          "/componente/send_email_verification_code/",
          requestOptions
        )
          .then(async function (response) {
            if (response.status === 200) {
            } else {
              if (response.status === 400) {
                Swal.fire(
                  "Error",
                  "No se encontro un contrato, porfavor dirigete a 'Mis Servicios' y elige un contrato",
                  "error"
                );
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
    });
  };

  const empaquetar = (value) => {
    window.sessionStorage.setItem("Nombreplanin", value.nombreplan);

    Swal.fire({
      title: JSON.stringify(value.nombreplan),
      text: "Quieres el paquetes seleccionado",

      confirmButtonColor: "#3085d6",

      confirmButtonText: "Comprar",
    }).then((result) => {
      Swal.fire({
        title: "Solicitar Servicio",
        html:
          `
          <form>
          <div class="m-3">
              <div class="row mb-3">
              <div class="col-6">
              <label for="NameLabelUpdate" class="labelFount">Propietario Nombre</label>
              <input type="text" id="swal-input1" class="form-control" placeholder="Propietario" value="">
          </div>
            <div class="col-6">
              <label for="NameLabelUpdate" class="labelFount">Propietario Apellido</label>
              <input type="text" id="swal-input10" class="form-control" placeholder="Propietario" value="">
          </div>
                  <div class="col-12">
                      <label for="NameLabelUpdate" class="labelFount">Documento</label>
                      <input type="text" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="` +
          dni.toString() +
          `" readonly>
                  </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                    <label for="NameLabelUpdate" class="labelFount">CEL Propietario</label>
                    <input type="text" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="">
                </div>
                
              </div>
              <div class="col-12">
                    <label for="NameLabelUpdate" class="labelFount">Correo propietario</label>
                    <input type="text" id="swal-input5" class="form-control" placeholder="Correo propietario" value="">
                </div>
              </div>
              <div class="mb-4">
                  <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                  <input id="swal-input6" class="form-control" type="file">
              </div>
              <div class="mb-4">
                  <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara frontal</label>
                  <input id="swal-input7" class="form-control" type="file">
              </div>
              <div class="mb-4">
                  <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara posterior</label>
                  <input id="swal-input8" class="form-control" type="file">
              </div>
              <div class="mb-4">
                  <label for="NameLabelUpdate" class="labelFount">Plan</label>
                  <h5>` +
          nombre_plan +
          `</h5>
                  <h5>$` +
                  precio[props.estrato] +
          `</h5>
              </div>

              <div class="row mb-4">
                <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                <textarea id="swal-input9" class="form-control" rows="5" placeholder="Para hacer saltos de linea presionar ENTER" ></textarea>
              </div>
          </div>
      </form>
`,

        focusConfirm: false,
        preConfirm: () => {
          Cate();
          var myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${token}`);

          var formdata = new FormData();
          formdata.append("address", adress);
          formdata.append("name", document.getElementById("swal-input1").value);
          formdata.append(
            "last_name",
            document.getElementById("swal-input10").value
          );
          formdata.append("cc", document.getElementById("swal-input2").value);
          formdata.append(
            "contact_phone",
            document.getElementById("swal-input3").value
          );
          formdata.append(
            "email_owner",
            document.getElementById("swal-input5").value
          );
          formdata.append("estrato", estrato);
          formdata.append("city_owner", city_owner);
          formdata.append("price_plan", precio[props.estrato]);
          formdata.append(
            "ad_cc",
            document.getElementById("swal-input7").files[0]
          );
          formdata.append(
            "ad_cc_back",
            document.getElementById("swal-input8").files[0]
          );
          formdata.append("category", Categoria);
          formdata.append(
            "rec_pub",
            document.getElementById("swal-input6").files[0]
          );
          formdata.append("plan", nombre_plan);
          formdata.append(
            "observations",
            document.getElementById("swal-input9").value
          );
          formdata.append("zone", zone);
          formdata.append("cdo", cdo);
          formdata.append("id_plan", value.id__planes);
          formdata.append("plan_type", value.tipoplan);
          formdata.append("id_plan_open", value.codigo_open);
          formdata.append("contract", suscri);
          formdata.append("localization", localization);

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          };

          return fetch(domain + "/portal/", requestOptions)
            .then(async function (response) {
              if (response.status === 201) {
                Swal.fire(
                  "Registro exitoso",
                  "Verifica tu cuenta en el correo",
                  "success"
                );
                Swal.fire({
                  title: JSON.stringify("Registro exitoso"),
                  text: "Verifica tu cuenta en el correo",
                  icon: "success",

                  confirmButtonColor: "#3085d6",

                  confirmButtonText: "Ver resumen",
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.href = "/Empaquetar";
                  }
                });
              } else {
                if (response.status === 400) {
                  Swal.fire({
                    icon: "error",
                    title:
                      "El documento de la persona ya esta registrado en otro servicio",
                    text: "Cambia la cedula del solicitante",
                    footer: '<a href="">Why do I have this issue?</a>',
                  });
                } else {
                  if (response.status === 500) {
                    Swal.fire({
                      icon: "error",
                      title: "Los campos no son correctos",
                      text: "Alguno de los campos no estan bien rellenados",
                      footer: '<a href="">Why do I have this issue?</a>',
                    });
                  }
                }
              }
            })
            .then((result) => console.log(result))
            .catch((error) => {
              console.log(error);
              Swal.showValidationMessage(
                `Request failed: Llenar todos los campos`
              );
            });
        },
      });
    });
  };

  const solicitudLogin = (value) => {
    Swal.fire({
      title: "Solicitar Servicio",
      html:
        `
            <form>
            <div class="m-3">
                <div class="row mb-3">
                <div class="col-6">
                <label for="NameLabelUpdate" class="labelFount">Propietario Nombre</label>
                <input type="text" id="swal-input1" class="form-control" placeholder="Propietario" value="">
            </div>
              <div class="col-6">
                <label for="NameLabelUpdate" class="labelFount">Propietario Apellido</label>
                <input type="text" id="swal-input10" class="form-control" placeholder="Propietario" value="">
            </div>
                    <div class="col-6">
                        <label for="NameLabelUpdate" class="labelFount">Documento</label>
                        <input type="text" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="">
                    </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                      <label for="NameLabelUpdate" class="labelFount">CEL Propietario</label>
                      <input type="text" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="">
                  </div>
                  
                </div>
                <div class="col-12">
                      <label for="NameLabelUpdate" class="labelFount">Correo propietario</label>
                      <input type="text" id="swal-input5" class="form-control" placeholder="Correo propietario" value="">
                  </div>
                </div>
                <div class="mb-4">
                    <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                    <input id="swal-input6" class="form-control" type="file">
                </div>
                <div class="mb-4">
                    <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara frontal</label>
                    <input id="swal-input7" class="form-control" type="file">
                </div>
                <div class="mb-4">
                    <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara posterior</label>
                    <input id="swal-input8" class="form-control" type="file">
                </div>
                <div class="mb-4">
                    <label for="NameLabelUpdate" class="labelFount">Plan</label>
                    <h5>` +
        nombre_plan +
        `</h5>
                    <h5>$` +
                    precio[props.estrato] +
        `</h5>
                </div>
  
                <div class="row mb-4">
                  <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                  <textarea id="swal-input9" class="form-control" rows="5" placeholder="Para hacer saltos de linea presionar ENTER" ></textarea>
                </div>
            </div>
        </form>
  `,

      focusConfirm: false,
      preConfirm: () => {
        Cate();
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);

        var formdata = new FormData();
        formdata.append("address", adress);
        formdata.append("name", document.getElementById("swal-input1").value);
        formdata.append(
          "last_name",
          document.getElementById("swal-input10").value
        );
        formdata.append("cc", document.getElementById("swal-input2").value);
        formdata.append(
          "contact_phone",
          document.getElementById("swal-input3").value
        );
        formdata.append(
          "email_owner",
          document.getElementById("swal-input5").value
        );
        formdata.append("estrato", estrato);
        formdata.append("city_owner", city_owner);
        formdata.append("price_plan", valor_plan);
        formdata.append(
          "ad_cc",
          document.getElementById("swal-input7").files[0]
        );
        formdata.append(
          "ad_cc_back",
          document.getElementById("swal-input8").files[0]
        );
        formdata.append("category", Categoria);
        formdata.append(
          "rec_pub",
          document.getElementById("swal-input6").files[0]
        );
        formdata.append("plan", nombre_plan);
        formdata.append(
          "observations",
          document.getElementById("swal-input9").value
        );
        formdata.append("cdo", cdo);
        formdata.append("zone", zone);
        formdata.append("id_plan", value.id__planes);
        formdata.append("plan_type", value.tipoplan);
        formdata.append("id_plan_open", value.codigo_open);
        formdata.append("localization", localization);

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        return fetch(domain + "/portal/", requestOptions)
          .then(async function (response) {
            if (response.status === 201) {
              Swal.fire(
                "Registro exitoso",
                "Verifica tu cuenta en el correo",
                "success"
              );
              Swal.fire({
                title: JSON.stringify("Registro exitoso"),
                text: "Verifica tu cuenta en el correo",
                icon: "success",

                confirmButtonColor: "#3085d6",

                confirmButtonText: "Ver resumen",
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "/Solicitud";
                }
              });
            } else {
              if (response.status === 400) {
                Swal.fire({
                  icon: "error",
                  title:
                    "El documento de la persona ya esta registrado en otro servicio",
                  text: "Cambia la cedula del solicitante",
                  footer: '<a href="">Why do I have this issue?</a>',
                });
              } else {
                if (response.status === 500) {
                  Swal.fire({
                    icon: "error",
                    title: "Los campos no son correctos",
                    text: "Alguno de los campos no estan bien rellenados",
                    footer: '<a href="">Why do I have this issue?</a>',
                  });
                }
              }
            }
          })
          .then((result) => console.log(result))
          .catch((error) => {
            console.log(error);
            Swal.showValidationMessage(
              `Request failed: Llenar todos los campos`
            );
          });
      },
    });
  };

  const calling = () => {
    Swal.fire({
      title: `${props.nombreplan}`,
      html: ` 
              
                    
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Nombre *</label>
                      <input id="nombre" class="swal2-input" placeholder="Nombre *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Apellido *</label>
                      <input id="apellido" class="swal2-input" placeholder="Apellido *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Telefono *</label>
                      <input id="telefono" class="swal2-input" placeholder="Telefono *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Correo electronico *</label>
                      <input id="mail" class="swal2-input" placeholder="Correo electronico *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Dirección *</label>
                      <input id="direccion" class="swal2-input" placeholder="Dirección *" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Barrio *</label>
                      <input id="neighborhood" class="swal2-input" placeholder="Barrio" style="width: 70%; margin: 0.3rem auto 0.5rem; border: 1px solid;">
                      <label style="display: block; width: 70%; margin: 0.5rem auto 0; text-align: left; font-weight: 500;">Ciudad *</label>
                      <select class="select swal2-input" id="mySelectElement" style="width: 70%; height: 3.4rem; margin: 0.3rem auto 1rem; border: 1px solid;">
                        <option value="Cali">Cali</option>
                        <option value="Jamundi">Jamundi</option>
                        <option value="Yumbo">Yumbo</option>
                        <option value="Candelaria">Candelaria</option>
                        <option value="Puerto tejaada">Puerto tejaada</option>
                        <option value="Palmira">Palmira</option>
                     </select>
                      `,

      confirmButtonColor: "#4a1272",
      confirmButtonText: "Enviar",
      showCloseButton: true,
      focusConfirm: false,
      preConfirm: () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          name: document.getElementById("nombre").value,
          last_name: document.getElementById("apellido").value,
          phone: document.getElementById("telefono").value,
          address: document.getElementById("direccion").value,
          mail: document.getElementById("mail").value,
          neighborhood: document.getElementById("neighborhood").value,
          city: document.getElementById("mySelectElement").value,
          service: props.nombreplan,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        return fetch(domain + "/portal/out/", requestOptions)
        .then((response) => {
          // Intenta convertir la respuesta en JSON
          return response.json().then((data) => {
            if (!response.ok) {
              // Si la respuesta no es OK, lanza un error con el mensaje devuelto
              const errorMsg = data.msg || response.statusText;
              throw new Error(errorMsg);
            }
            // Si todo va bien, muestra el mensaje de éxito
            Swal.fire({
              icon: "success",
              title: "Perfecto!",
              text: "Nos contactaremos contigo muy pronto!",
            });
          });
        })
        .catch((error) => {
          // Imprime el mensaje de error en la consola
          console.error(error.message);
          // Muestra el mensaje de error en la validación de Swal
          Swal.showValidationMessage(`Hay errores en el formulario, ${error.message}`);
        });
      },
    });
  };

  const megasadicionales = (e) => {
    if (e > 0) {
      return (
        <h2 style={{ fontSize: "40px" }}>
          <b>{e + parseInt(props.velocidad)}</b>
          <h6 className="presnorm">{Math.trunc(props.velocidad)}</h6>
          <h3 style={{ fontSize: "15px" }}>Megas Simétricas</h3>
        </h2>
      );
      // <div>
      //   <h2 style={{fontSize: "70px"}}><b>{props.velocidad}</b></h2><h3 style={{fontSize: "25px"}}>Megas Simétricas</h3>
      //  </div>
    }
  };

  const fun = () => {
    props.funcion(props);
  };

  const solicitud = (value) => {
    try {
      window.sessionStorage.setItem("Nombreplan", value.nombreplan);
      window.sessionStorage.setItem("Plan", value.tipoplan);
      window.sessionStorage.setItem("Velocidad", value.velocidad);
      window.sessionStorage.setItem("PrecioEmpresa", value.precio_empresa);
      window.sessionStorage.setItem("id_plan", value.id__planes);
      window.sessionStorage.setItem("plan_type", value.tipoplan);
      window.sessionStorage.setItem("id_plan_open", value.codigo_open);

      Swal.fire({
        title: JSON.stringify(value.nombreplan),
        text: "¿Quieres el paquetes seleccionado?",
        confirmButtonColor: "#3085d6",

        confirmButtonText: "Comprar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = value.ruta;
        }
      });
    } catch {
      console.log("No mover");
    }
  };

  const icons_change = (tipoplan) => {
    if (tipoplan === "Triple") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Phone
                className="Telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <ModernTv
                className="icono-television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Dupla") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>

          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Phone
                className="Telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b >Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    } else if (tipoplan === "Doble") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Phone
                className="Telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <ModernTv
                className="icono-television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Internet") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    }
  };

  return (
    <div
      className="card"
      style={{ boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)" }}
    >
      <div
        className="plan pospago"
        dane="76001,76520,76892,76130,76364"
        valor-numerico={parseInt(precio[props.estrato])}
        estrato="1,2,3,4,5,6"
        titulo={props.nombreplan}
      >
        <div className="operador" operador-nit="890399003" style={{ display: "none" }}>EMCALI</div>
        <img className="operador-logo" src="https://c748596267.imgdist.com/pub/bfra/zs95jvh4/uy4/tyz/u0a/logo_emcali.png" alt="EMCALI" style={{ display: "none" }} />
        <div className="url-comercial" style={{ display: "none" }}>https://portalservicios.emcali.net.co/planes</div>
        {props.tipoplan !== "Internet" && (
          <div className="telefonia" style={{ display: "none" }}>
            <span className="minutos-incluidos">ilimitados</span> minutos a destinos fijos locales
          </div>
        )}
        {props.tipoplan !== "Doble" && (
          <div className="internet" tecnologia="108" style={{ display: "none" }}>
            <div>Internet de <span className="velocidad-bajada">{props.velocidad}</span> Mbps de bajada</div>
            <div>Internet de <span className="velocidad-subida">{props.velocidad}</span> Mbps de subida</div>
          </div>
        )}
        {(props.tipoplan === "Triple" || props.tipoplan === "Doble") && (
          <div className="television" tecnologia="3" style={{ display: "none" }}>
            <span className="canales-hd">113</span> canales
          </div>
        )}

      <div className="caracteristica-adicional">
        <h6 style={{ marginTop: "1rem", display: "" }}>Plan residencial</h6>
      </div>
      <CardContent key={props.id}>
        <div style={{ padding: "0" }}>
          <h2 style={{ fontSize: "30px" }}>
            {/* <h6 style={{ marginBottom: "0.6rem" }}>
              <b>Recibes</b>
            </h6> */}
            <b
              style={{
                color: "#4a1272",
                display: "inline-flex",
                justifyContent: "center",
              }}
            >
              {" "}
              {props.velocidad} Megas
              <DataTransferBoth style={{ width: "10%" }} />
            </b>
          </h2>
          {/* <h3 style={{ fontSize: "15px" }}>Megas Simétricas</h3> */}
        </div>

        {/* <div>
          <img className="tar-img" src={image2} alt="Imagen Win Sports" />
        </div> */}

        <div
          className="valor card-title pricing-card-title"
          valor-numerico={parseInt(precio[props.estrato])}
        >
          <br></br>
          <h5 style={{ fontSize: "22px" }}>
          <h6>Valor desde*</h6>
            <b>
              {new Intl.NumberFormat("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
              }).format(Math.trunc(precio[props.estrato]))}
            </b>
            
            <h6>Mensual</h6>
            <h6 style={{fontSize:"10px"}}>Sujeto a verificacion</h6>
          </h5>
        </div>
        <div className="mt-[1.3rem]"></div>
        <div className="row">{icons_change(props.tipoplan)}</div>

        {/*<div className="flex justify-center items-start flex-col">{icons_change(props.tipoplan)}</div>*/}

        {/* <div>
          <b>Persona juridica:</b><br></br>
          <h5>
            ${props.precio_empresa}
            <h6>x1 mes</h6>
          </h5>
        </div> */}
        {/* <hr></hr> */}
        <div className="row px-3">
          <button className="action-button buy-button" onClick={() => fun()}>
            <Cart className="icon" style={{}} />
              <b>{props.nombreButton}</b>
          </button>
        </div>
        <div className="row px-3 mt-2" style={{ display: props.display }}>
          <button
            className="action-button phone-button"
            onClick={() => {
              calling();
            }}
          >
            <Phone className="icon" style={{}} />
            <h6 className="m-0">
              <b>Te asesoramos</b>
            </h6>
          </button>
        </div>
      </CardContent>
      </div>
    </div>
  );
}

export default Cardcomprasin;
